import React from "react";
import { useTranslation } from "react-i18next";

/** Previous and Next over a server-paged list, with where the reader is in it. */
const Pager: React.FunctionComponent<{
  /** 1-based. */
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
}> = ({ page, pageCount, onPage }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-3 text-sm text-gray-500">
      <button
        type="button"
        className="btn-default py-1.5 text-xs font-semibold"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        {t("shared.table.pagination.previous")}
      </button>
      <span>
        {t("shared.table.pagination.page_of", { page, total: pageCount })}
      </span>
      <button
        type="button"
        className="btn-default py-1.5 text-xs font-semibold"
        disabled={page >= pageCount}
        onClick={() => onPage(page + 1)}
      >
        {t("shared.table.pagination.next")}
      </button>
    </div>
  );
};

export default Pager;
